import { useMutation } from '@tanstack/react-query';
import { makeBackendApi } from 'services/BackendApi';
import { EUploadTag } from 'services/BackendApi/types/UploadResponse';

export const useUploadInvoiceMutation = () => {
  return useMutation({
    mutationFn: async ({ file, bookingUuid }: { file: File; bookingUuid: string }) => {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('tag', EUploadTag.FINANCE_PURCHASE_INVOICE);
      formData.append('displayName', file.name);
      formData.append('ownerType', 'Booking');
      formData.append('ownerUuid', bookingUuid);
      const response = await makeBackendApi().uploadFile(formData);
      return response.data;
    },
  });
};
